import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrganizationRoutingModule } from './organization-routing.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { SharedModule } from '../shared/shared.module';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { JobsComponent } from './jobs/jobs.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [AboutUsComponent, ContactUsComponent, JobsComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    OrganizationRoutingModule
  ]
})
export class OrganizationModule { }
